import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        /** @type {'top'|'bottom'|'left'|'right'} */
        tooltipPosition: {
            type: String,
            default: 'top'
        },
        transition: String
    },
    computed: {
        transitionProp() {
            if (this.transition) return this.transition
            switch (this.tooltipPosition) {
                case 'top':
                    return 'slide-y-reverse-transition'
                case 'bottom':
                default:
                    return 'slide-y-transition'
                case 'left':
                    return 'slide-x-reverse-transition'
                case 'right':
                    return 'slide-x-transition'
            }
        },
        tooltipPositionProps() {
            return {
                [this.tooltipPosition]: true,
                transition: this.transitionProp
            }
        }
    }
})
